import {
  Box,
  Fab,
  Link,
  Typography,
} from '@mui/material'
import { Info } from '@mui/icons-material'
import { TpTooltip } from '~/components/tp-tooltip'

const LEAVE_DELAY = 500
const INCLUDE_ECMWF_DISLACIMER = false
const ECMWF_DISCLAIMER = "\
Generated using or contains modified Copernicus Climate Change Service information 2026. Neither the European \
Commission nor ECMWF is responsible for any use that may be made of the Copernicus information or data it contains.\
"

export const Era5DisclaimerTooltip = () => {
  return (
    <TpTooltip
      title={
        <Box >
          <Typography>
            Climate data from Copernicus Climate Change Service (C3S) Climate Data Store (CDS) ERA5-Land hourly data.
            <br/>
            The 2m-temperature statistic is collected on a <strong>20 year (2006-2025)</strong> average.
            Recent temperatures may differ from historic frost dates due to changing climates!
            <br/>
            {INCLUDE_ECMWF_DISLACIMER && ECMWF_DISCLAIMER}
          </Typography>
          <Typography sx={{ mt: 1 }}>
            Source:{' '}
            <Link
              href="https://cds.climate.copernicus.eu/datasets/reanalysis-era5-land?tab=overview"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'primary.main' }}
            >
              Copernicus ERA5-Land
            </Link>
          </Typography>
        </Box>
      }
      placement="top"
      enterTouchDelay={0}
      followCursor={false}
      leaveTouchDelay={LEAVE_DELAY}
      leaveDelay={LEAVE_DELAY}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -12],
              },
            },
          ],
        },
      }}
    >
      <Fab
        size="small"
        disableRipple
        disableFocusRipple
        tabIndex={-1}
        sx={{
          position: 'absolute',
          top: 14,
          right: 16,
          bgcolor: 'background.paper',
          boxShadow: 'none',
          pointerEvents: 'hover',
          cursor: 'unset',
          '&:active': {
            boxShadow: 'none',
            bgcolor: 'background.paper',
          },
          '&:hover': {
            bgcolor: 'background.paper',
          }
        }}
      >
        <Info color='primary' />
      </Fab>
    </TpTooltip>
  )
}